import React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../utils/cn";

const spinnerVariants = cva(
  "animate-spin rounded-full border-2 border-current border-t-transparent shrink-0",
  {
    variants: {
      size: {
        xs: "h-3 w-3",
        sm: "h-4 w-4",
        md: "h-6 w-6",
        lg: "h-8 w-8",
        xl: "h-12 w-12",
      },
      color: {
        primary: "text-blue-600",
        white: "text-white",
        gray: "text-gray-400",
        green: "text-green-600",
        red: "text-red-600",
        current: "text-current",
      },
    },
    defaultVariants: {
      size: "md",
      color: "primary",
    },
  },
);

export interface SpinnerProps extends VariantProps<typeof spinnerVariants> {
  label?: string;
  className?: string;
  wrapperClassName?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({
  className,
  wrapperClassName,
  size,
  color,
  label = "Loading...",
}) => {
  return (
    <div
      role="status"
      aria-label={label}
      className={cn(
        "inline-flex items-center justify-center",
        wrapperClassName,
      )}
    >
      <div className={cn(spinnerVariants({ size, color }), className)} />
      <span className="sr-only">{label}</span>
    </div>
  );
};

Spinner.displayName = "Spinner";

// Day 9 complete
